import { render, staticRenderFns } from "./BoolSwitch.vue?vue&type=template&id=e11cdb06&"
import script from "./BoolSwitch.vue?vue&type=script&lang=js&"
export * from "./BoolSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports